var _defs, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgActivityLogs(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "27px",
    height: "30px",
    viewBox: "0 0 27 30",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Activity logs") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    x1: "25.794671%",
    y1: "33.4420652%",
    x2: "50%",
    y2: "62.0261199%",
    id: "linearGradient-1"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFC444",
    offset: "0%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF8400",
    offset: "100%"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M16.8203586,23.9316239 C16.6956274,26.199382 14.8090309,28 12.5,28 C10.1909691,28 8.3043726,26.199382 8.17964144,23.9316239 L2.88937173,23.9316239 C1.29371139,23.9316239 0,22.646566 0,21.0598291 C0,19.4752435 1.29262692,18.1880342 2.8856187,18.1880342 C2.88374745,18.1880342 2.88461538,12.4440852 2.88461538,12.4440852 C2.88461538,8.39836887 5.42588769,4.85127832 9.13461538,3.47428877 L9.13461538,3.34815547 C9.13461538,1.49957733 10.6434889,0 12.5,0 C14.3585026,0 15.8653846,1.49867492 15.8653846,3.34815547 L15.8653846,3.47436856 C19.5740208,4.85154143 22.1153846,8.39922098 22.1153846,12.4440852 L22.1153846,18.1871998 C23.7049963,18.1880342 25,19.474744 25,21.0598291 C25,22.6448325 23.7052722,23.9316239 22.1106283,23.9316239 L16.8203586,23.9316239 Z M14.8919771,23.9316239 C14.7713703,25.1409661 13.7464779,26.0854701 12.5,26.0854701 C11.2535221,26.0854701 10.2286297,25.1409661 10.1080229,23.9316239 L10.1080229,23.9316239 Z M12.5,1.91452991 C13.2968498,1.91452991 13.9423077,2.55647237 13.9423077,3.34815547 L13.9423077,3.34815547 L13.9423077,4.88582563 L14.637335,5.08543175 C17.9018508,6.02297374 20.1923077,9.00978405 20.1923077,12.4440852 L20.1923077,12.4440852 L20.1923077,18.1871998 C20.1923077,19.2473078 21.0517994,20.1025641 22.1143813,20.1025641 C22.6437577,20.1025641 23.0769231,20.5329553 23.0769231,21.0598291 C23.0769231,21.58674 22.6439149,22.017094 22.1106283,22.017094 L22.1106283,22.017094 L2.88937173,22.017094 C2.35482707,22.017094 1.92307692,21.5882318 1.92307692,21.0598291 C1.92307692,20.5325002 2.3548225,20.1025641 2.8856187,20.1025641 C3.94609822,20.1025641 4.80769231,19.244272 4.80769231,18.1871998 L4.80769231,18.1871998 L4.80769231,12.4440852 C4.80769231,9.00894668 7.09797577,6.02283542 10.3626276,5.08539681 L10.3626276,5.08539681 L11.0576923,4.88581032 L11.0576923,3.34815547 C11.0576923,2.55768336 11.7048328,1.91452991 12.5,1.91452991 Z",
    id: "path-2"
  }), /*#__PURE__*/React.createElement("filter", {
    x: "-8.0%",
    y: "-3.6%",
    width: "116.0%",
    height: "114.3%",
    filterUnits: "objectBoundingBox",
    id: "filter-3"
  }, /*#__PURE__*/React.createElement("feOffset", {
    dx: 0,
    dy: 1,
    in: "SourceAlpha",
    result: "shadowOffsetOuter1"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.5,
    in: "shadowOffsetOuter1",
    result: "shadowBlurOuter1"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "0 0 0 0 0   0 0 0 0 0   0 0 0 0 0  0 0 0 0.129820497 0",
    type: "matrix",
    in: "shadowBlurOuter1"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Symbols",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "noun_notification_1594279-(1)",
    transform: "translate(1.000000, 0.000000)",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Shape"
  }, /*#__PURE__*/React.createElement("use", {
    fill: "black",
    fillOpacity: 1,
    filter: "url(#filter-3)",
    xlinkHref: "#path-2"
  }), /*#__PURE__*/React.createElement("use", {
    fill: "url(#linearGradient-1)",
    xlinkHref: "#path-2"
  }))))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgActivityLogs);
export default __webpack_public_path__ + "static/media/activity_logs.e6c3b4033630e3dac6b67bf3fef50b13.svg";
export { ForwardRef as ReactComponent };